import { render } from "./PublicationSettings.vue.js?vue&type=template&id=745df636!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSettings.vue?vue&type=template&id=745df636"
import script from "./PublicationSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSettings.vue?vue&type=script&lang=js"
export * from "./PublicationSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "745df636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('745df636', __exports__)) {
    api.reload('745df636', __exports__)
  }
  
  module.hot.accept("./PublicationSettings.vue.js?vue&type=template&id=745df636!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationSettings.vue?vue&type=template&id=745df636", () => {
    api.rerender('745df636', render)
  })

}


export default __exports__